import { assertValue } from '@libs/utils';

import { BracketType } from '../moneyFormatters/RelativeMoneyFormatter.model';

import type { LabelFormatterTypes } from './LabelFormatter.model';
import { LabelFormatterType } from './LabelFormatter.model';

// TODO: Add tests

export function getLabelFormatterPropsForSingleValue(
  formatter: LabelFormatterTypes,
  newValue: number
): LabelFormatterTypes {
  switch (formatter.formatterType) {
    case LabelFormatterType.MoneyFormatter:
      return {
        formatterType: formatter.formatterType,
        data: {
          price: newValue,
          minPrice: formatter.data.minPrice,
          font: formatter.data.font,
          color: formatter.data.color,
        },
      };
    case LabelFormatterType.TravelDurationFormatter:
      return {
        formatterType: formatter.formatterType,
        data: {
          value: newValue,
          font: formatter.data.font,
          color: formatter.data.color,
        },
      };
    default:
      return formatter;
  }
}

export function getLabelFormatterPropsForRangeValue(
  formatter: LabelFormatterTypes,
  newValue: number[]
): LabelFormatterTypes {
  switch (formatter.formatterType) {
    case LabelFormatterType.TimeRangeFormatter:
      return {
        formatterType: formatter.formatterType,
        data: {
          value: newValue,
          font: formatter.data.font,
          color: formatter.data.color,
        },
      };

    case LabelFormatterType.RelativeMoneyFormatter: {
      const price = newValue[0];
      const basePrice = newValue[1];
      assertValue(
        price,
        `LabelFormatter.helper.ts > getLabelFormatterPropsForRangeValue > LabelFormatterType.RelativeMoneyFormatter > price > ${newValue[0]}`
      );
      assertValue(
        basePrice,
        `LabelFormatter.helper.ts > getLabelFormatterPropsForRangeValue > LabelFormatterType.RelativeMoneyFormatter > basePrice > ${newValue[1]}`
      );
      return {
        formatterType: formatter.formatterType,
        data: {
          price,
          basePrice,
          font: formatter.data.font,
          color: formatter.data.color,
          bracketType: BracketType.None,
        },
      };
    }
    default:
      return formatter;
  }
}
